import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import filterIcon from "../../assets/icons/Filter contacts.svg";
import crossIcon from "../../assets/icons/x-circle.svg";
import { ProjectDropdown } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import AssigneeModal from "../../pages/dynamic/ASC_AssigneeModal";
import "./TaskFilter2.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const TaskFilter = (props) => {
  const location = useLocation();
  const { taskId, taskIds } = useParams();
  const dispatch = useDispatch();
  const textAreaRef = useRef("");

  const userId = window.localStorage.getItem("userid");
  const userimageurl = window.localStorage.getItem("userimageurl");
  const firstname = window.localStorage.getItem("firstname");

  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );

  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  const [filtersPopupShow, setFiltersPopupShow] = useState(false);

  const [allFilterOption, setAllFilterOption] = useState(false);
  const [projectFilterOption, setProjectFilterOption] = useState(false);
  const [coWorkerFilterOption, setCoWorkerFilterOption] = useState(true);

  const [projectData, setProjectData] = useState([]);
  const [searchProject, setSearchProject] = useState("");

  const [projectBoxShow, setProjectBoxShow] = useState(false);
  const [assigneeModelOpen, setAssigneeModelOpen] = useState(false);

  const [assigneeData, setAssigneeData] = useState([
    {
      id: userId,
      name: firstname,
      img: userimageurl,
    },
  ]);

  // DEFAULT LOGIN USER FILTER
  useEffect(() => {
    props?.setFilterItem2([
      {
        types: "Co-Worker",
        id: userId,
        name: firstname,
        img: userimageurl,
      },
    ]);
  }, []);

  // FETCH PROJECTS
  useEffect(() => {
    dispatch(ProjectDropdown());
  }, []);

  useEffect(() => {
    if (fetchProjectDropdown?.status) {
      setProjectData(fetchProjectDropdown.data);
    }
  }, [fetchProjectDropdown]);

  // SYNC ASSIGNEE DATA TO FILTERS
  useEffect(() => {
    if (!coWorkerFilterOption) return;

    props?.setFilterItem2((prev) => {
      const nonCoworkers = prev.filter(
        (x) => x.types !== "Co-Worker" && x.types !== "All",
      );

      if (assigneeData.length === 0) {
        return nonCoworkers.length
          ? nonCoworkers
          : [{ types: "All", id: "", name: "" }];
      }

      const coworkers = assigneeData.map((user) => ({
        types: "Co-Worker",
        id: user.id,
        name: `${user.name || user.firstName || ""} ${user.lastName || ""}`.trim(),
        img: user.img || user.imageurl,
      }));

      return [...nonCoworkers, ...coworkers];
    });
  }, [assigneeData, coWorkerFilterOption]);

  // ADD USERS
  const addUsersData = (asc, string) => {
    if (string === "single") {
      setAssigneeData((prev) => {
        const exists = prev.some((x) => x.id === asc.id);
        if (exists) return prev;
        return [...prev, asc];
      });
    }

    if (asc.length > 1) {
      setAssigneeData((prev) => {
        const newUsers = asc.filter(
          (user) => !prev.some((x) => x.id === user.id),
        );
        return [...prev, ...newUsers];
      });
    }
  };

  // REMOVE USERS
  const removeUsersData = (asc, string) => {
    if (string === "single") {
      setAssigneeData((prev) => prev.filter((x) => x.id !== asc.id));
    }

    if (asc.length > 1) {
      setAssigneeData((prev) =>
        prev.filter((x) => !asc.some((user) => user.id === x.id)),
      );
    }
  };

  // ALL SELECT
  const handleAllSelect = () => {
    setAllFilterOption(true);
    setProjectFilterOption(false);
    setCoWorkerFilterOption(false);

    setAssigneeData([]);

    props?.setFilterItem2([
      {
        types: "All",
        id: "",
        name: "",
      },
    ]);

    setFiltersPopupShow(false);
    setProjectBoxShow(false);
    setAssigneeModelOpen(false);
  };

  // PROJECT SELECT
  const handleProjectSelect = (item) => {
    setAllFilterOption(false);
    setProjectFilterOption(true);

    props?.setFilterItem2((prev) => {
      const cleaned = prev.filter(
        (x) => x.types !== "All" && x.types !== "Projects",
      );

      return [
        ...cleaned,
        {
          types: "Projects",
          id: item.projectid,
          name: item.projectname,
        },
      ];
    });

    setProjectBoxShow(false);
    setFiltersPopupShow(false);
  };

  // REMOVE FILTER
  const removeFilter = (type, id) => {
    let updatedFilters = props.filterItem2.filter(
      (item) => !(item.types === type && item.id === id),
    );

    if (!updatedFilters.length) {
      updatedFilters = [{ types: "All", id: "", name: "" }];
      setAllFilterOption(true);
      setProjectFilterOption(false);
      setCoWorkerFilterOption(false);
    }

    props.setFilterItem2(updatedFilters);

    if (type === "Projects") {
      setProjectFilterOption(false);
    }

    if (type === "Co-Worker") {
      setAssigneeData((prev) => prev.filter((x) => x.id !== id));

      const remaining = updatedFilters.filter((x) => x.types === "Co-Worker");

      if (!remaining.length) {
        setCoWorkerFilterOption(false);
      }
    }
  };

  return (
    <div className="position-relative w-100">
      <div className="pointer filterLabel">
        <span>
          {/* Filter */}
          {t("Filter")}
        </span>

        <img
          src={filterIcon}
          alt=""
          className="pro-part-add-itm-btn-icn"
          onClick={() => setFiltersPopupShow(!filtersPopupShow)}
        />

        {props?.filterItem2?.map((item) => (
          <div key={`${item.types}-${item.id}`} className="borderArea px-2">
            <div className="d-flex gap-2 p-1 align-items-center">
              <span style={{ color: "#707070", fontWeight: "400" }}>
                {item.types}
              </span>

              {item.img ? (
                <img
                  src={item.img}
                  alt=""
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <span>{item.name}</span>
              )}
            </div>

            <p
              className="mb-0 mx-2"
              style={{ borderRight: "1px solid #707070" }}
            ></p>

            <p
              className="mb-0 pt-1 pointer"
              onClick={() => removeFilter(item.types, item.id)}
            >
              X
            </p>
          </div>
        ))}
      </div>

      {/* FILTER POPUP */}
      {filtersPopupShow && (
        <div className="filter-modal">
          <img
            className="d-flex ms-auto me-1 pointer"
            alt=""
            src={crossIcon}
            style={{ width: "18px", height: "18px" }}
            onClick={() => setFiltersPopupShow(false)}
          />

          <div className="form-check underTexts">
            <input
              className="form-check-input pointer"
              id="ASC_All"
              type="checkbox"
              // checked={allFilterOption}
              checked={
                props.filterItem2.length === 1 &&
                props.filterItem2[0]?.types === "All"
              }
              onClick={handleAllSelect}
            />
            <label htmlFor="ASC_All" className="form-check-label pointer">
              <p className="mb-0">
                {/* All */}
                {t("All")}
              </p>
            </label>
          </div>

          <div className="form-check underTexts py-3">
            <input
              className="form-check-input pointer"
              type="checkbox"
              id="ASC_Project"
              // checked={projectFilterOption}
              checked={props.filterItem2.some(
                (item) => item.types === "Projects",
              )}
              onClick={() => {
                setProjectBoxShow(true);
                setAssigneeModelOpen(false);
                setAllFilterOption(false);
              }}
            />
            <label
              htmlFor="ASC_Project"
              className="form-check-label d-flex align-items-center pointer"
            >
              <p className="mb-0">
                {/* project */}
                {t("project")}
              </p>
              <h3 className="mb-0 ms-4 ps-4">{">"}</h3>
            </label>
          </div>

          <div className="form-check underTexts">
            <input
              className="form-check-input pointer"
              type="checkbox"
              id="ASC_CoWorker"
              // checked={coWorkerFilterOption}
              checked={props.filterItem2.some(
                (item) => item.types === "Co-Worker",
              )}
              onClick={() => {
                setCoWorkerFilterOption(true);
                setAllFilterOption(false);
                setAssigneeModelOpen(true);
                setProjectBoxShow(false);
              }}
            />
            <label
              htmlFor="ASC_CoWorker"
              className="form-check-label d-flex align-items-center pointer"
            >
              <p className="mb-0">
                {/* Co-Worker */}
                {t("Co-Worker")}
              </p>
              <h3 className="ms-auto mb-0 ps-4">{">"}</h3>
            </label>
          </div>
        </div>
      )}

      {/* PROJECT POPUP */}
      {projectBoxShow && (
        <div className="poject-modal ps-4 pt-3">
          <p className="opacity-50">{t("Choose a Project")}</p>
          <div className="d-flex align-items-center gap-2">
            <input
              className="finterInput p-1"
              placeholder={t("Search")}
              value={searchProject}
              onChange={(e) => setSearchProject(e.target.value)}
            />

            <img
              className="ms-2 pointer"
              alt=""
              src={crossIcon}
              style={{ width: "18px", height: "18px" }}
              onClick={() => setProjectBoxShow(false)}
            />
          </div>

          <div className="projectDataContainer my-3">
            {projectData
              ?.filter((x) =>
                x.projectname
                  .toLowerCase()
                  .includes(searchProject.toLowerCase()),
              )
              ?.map((item) => (
                <div
                  key={item.projectid}
                  className="d-flex gap-1 pointer"
                  onClick={() => handleProjectSelect(item)}
                >
                  <p>{item.projectname}</p> - <p>{item.clientname}</p>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* COWORKER MODAL */}
      {assigneeModelOpen && (
        <AssigneeModal
          sendingData={assigneeData}
          addUsersData={addUsersData}
          removeUsersData={removeUsersData}
          closeAssigneeModal={() => setAssigneeModelOpen(false)}
          showWorkersTab={true}
          showTeamsTab={false}
          showSelectedDisabled={true}
          style={{
            position: "absolute",
            left: "235px",
            width: "500px",
            maxWidth: "500px",
            zIndex: 2,
          }}
        />
      )}
    </div>
  );
};

export default TaskFilter;
